import { createSlice, PayloadAction } from "@reduxjs/toolkit"
import { RootState } from "../store"
import { IChatInfo } from "../../types/chat"

export interface modalSliceState {
  messagesModalIsOpen: boolean
  messagesModalFirstChat: IChatInfo | null
  isOrderModalOpen: boolean
}

const initialState: modalSliceState = {
  messagesModalIsOpen: false,
  messagesModalFirstChat: null,
  isOrderModalOpen: false,
}

export const ModalSlice = createSlice({
  name: "modals",
  initialState,
  reducers: {
    setMessagesModalIsOpen: (state: modalSliceState, action: PayloadAction<boolean>) => {
      state.messagesModalIsOpen = action.payload
    },
    setMessagesModalFirstChat: (state: modalSliceState, action: PayloadAction<IChatInfo | null>) => {
      state.messagesModalFirstChat = action.payload
    },
    setOrderModalOpen: (state: modalSliceState, action: PayloadAction<boolean>) => {
      state.isOrderModalOpen = action.payload
    },
  },
})

export const { setMessagesModalIsOpen, setMessagesModalFirstChat, setOrderModalOpen } = ModalSlice.actions

export const getMessagesModal = (state: RootState) => state[ModalSlice.name].messagesModalIsOpen
export const getMessagesModalFirstChat = (state: RootState) => state[ModalSlice.name].messagesModalFirstChat
export const selectModals = (state: any): modalSliceState => state[ModalSlice.name]
